<template>
  <div class="footer">
    <div class="footer-left">
      <div class="footer-left-info">
        <router-link class="footer-left-info-logo" to="/"></router-link>
        <div class="footer-left-info-address">
          Room 503,Building E6,OCT LOFT, Nanshan District,Shenzhen
        </div>
        <div class="footer-left-info-phone">400-185-8666</div>
      </div>
    </div>
    <div class="footer-right">
      <div class="footer-right-info">
        <router-link class="footer-right-info-about-us" to="/about-us/brief"
          >Abouts Us</router-link
        >
        <router-link class="footer-right-info-contact-us" to="/contact-us"
          >Contact Us</router-link
        >
      </div>
    </div>
    <div class="footer-copy-right">
      Copyright 2007-2023 © 深圳市聚橙网络技术有限公司 | <a href="https://beian.miit.gov.cn/">粤ICP备09218027号-9</a><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004863"><span class="footer-copy-right-icon"></span>粤公网安备 44030502004863号</a>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.footer {
  height: 299px;
  background-color: #f2f2f2;
  vertical-align: middle;
  position: relative;
  &-left {
    width: 50%;
    height: 100%;
    text-align: right;
    display: inline-block;
    vertical-align: middle;
    &-info {
      width: 600px;
      text-align: left;
      display: inline-block;
      &-logo {
        margin-top:30px;
        width: 172px;
        height: 54px;
        display: inline-block;
        background-image: url("../assets/logo.png");
        background-size: 100% 100%;
      }
      &-address {
        width: 230px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(46, 41, 37, 1);
        line-height: 36px;
        text-align: left;
        margin-top: 16px;
      }
      &-phone {
        width: 230px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(46, 41, 37, 1);
        line-height: 36px;
        text-align: left;
      }
    }
  }
  &-right {
    width: 50%;
    height: 100%;
    display: inline-block;
    text-align: left;
    vertical-align: middle;
    &-info {
      margin-top: 125px;
      width: 600px;
      text-align: right;
      display: inline-block;
      &-about-us {
        font-size: 20px;
        font-weight: 400;
        color: rgba(46, 41, 37, 1);
        line-height: 36px;
        display: block;
        cursor: pointer;
      }
      &-contact-us {
        font-size: 20px;
        font-weight: 400;
        color: rgba(46, 41, 37, 1);
        line-height: 36px;
        display: block;
        cursor: pointer;
      }
    }
  }
  &-copy-right {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    font-size: 14px;
    height: 16px;
    color: #7d7a78;
    line-height: 16px;
    white-space: nowrap;
    vertical-align: middle;
    a {
      color: #2E2925;
      text-decoration-color:transparent;
    }
    &-icon{
      vertical-align: bottom;
      background-image: url('../assets/police.png');
      width: 18px;
      height: 20px;
      background-position: center;
      background-repeat: no-repeat;
      display: inline-block;
      margin-left: 20px;
      margin-right: 8px;
    }
  }
}
</style>